"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro právi se subjekty ve vztahu k základním registrům - ZR. Generated from cz.marbes.api.subjekt.v1.SubjektZrService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:45Z                      #

// ##############################################################

var SubjektZrApi = function () {
  function SubjektZrApi() {
    (0, _classCallCheck3.default)(this, SubjektZrApi);
  }

  (0, _createClass3.default)(SubjektZrApi, null, [{
    key: "aktualizovat",

    /**
     * Provede aktualizaci subjektu, který je napojen na ZR.
     *
     * @param subjektId id subjektu
     */
    value: function aktualizovat(subjektId) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/" + subjektId + "/aktualizujZeZr");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, 0, headers));
    }

    /**
     * Obnovit POZASTAVENOU vazbu na ZR. Pokud je již obnovená, nic se nestane.
     *
     * @param subjektId id subjektu
     */

  }, {
    key: "obnovitVazbu",
    value: function obnovitVazbu(subjektId) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/" + subjektId + "/obnovitVazbu");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, 0, headers));
    }

    /**
     * U subjektu zruší vazbu na zr.
     *
     * @param subjektId id subjektu
     */

  }, {
    key: "zrusitVazbu",
    value: function zrusitVazbu(subjektId) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/" + subjektId + "/zrusitVazbuZr");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, 0, headers));
    }

    /**
     * Notifikování a odnotifikování subjektu od posílání změn ze základních retistrů.
     *
     * @param subjektId 
     * @param notifikace 
     */

  }, {
    key: "nastavNotifikaceSubjektu",
    value: function nastavNotifikaceSubjektu(subjektId, notifikace) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/" + subjektId + "/nastavNotifikace/" + notifikace);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Pozastaví u subjektu vazbu na ZR, stav zr bude ve stavu pozastaven - nebude prováděna aktulizace ze ZR. Pokud je již subjekt poyastaven, nic se nestane. Pozastavením je automaticky zrušena notifikace.
     *
     * @param subjektId id subjektu
     */

  }, {
    key: "pozastavitVazbu",
    value: function pozastavitVazbu(subjektId) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjekty/" + subjektId + "/pozastavitVazbu");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, 0, headers));
    }
  }]);
  return SubjektZrApi;
}();

exports.default = SubjektZrApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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